import React from "react";
import { Link } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";
import { usePlaces } from "../context/PlacesContext";
import { PlaceCard, SectionLabel } from "../components/Bits";

export default function Favourites() {
  const { favPlaces, loading } = usePlaces();

  return (
    <div className="pt-[68px]">
      <div className="bg-ink text-paper relative grain">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 relative">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-8 bg-brass" />
            <span className="eyebrow text-brass">Your list</span>
          </div>
          <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl font-semibold display-balance max-w-2xl">
            Places you want to try.
          </h1>
          <p className="text-paper/60 mt-5 max-w-xl text-lg">
            Every place you save lives here — your personal shortlist, ready whenever you are.
          </p>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        {loading ? (
          <p className="text-ink-soft font-serif text-2xl">Loading…</p>
        ) : favPlaces.length ? (
          <>
            <SectionLabel>{favPlaces.length} saved {favPlaces.length === 1 ? "place" : "places"}</SectionLabel>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-14 mt-10">
              {favPlaces.map((p, i) => <PlaceCard key={p.id} place={p} index={i} />)}
            </div>
          </>
        ) : (
          <div className="py-24 text-center">
            <div className="w-16 h-16 mx-auto rounded-full bg-ink/5 flex items-center justify-center">
              <Heart className="w-7 h-7 text-claret" />
            </div>
            <h2 className="font-serif text-3xl font-semibold mt-6">Your list is empty.</h2>
            <p className="text-ink-soft mt-3 max-w-md mx-auto">
              Tap the heart on any place to save it here for later. Start exploring to build your shortlist.
            </p>
            <Link to="/explore" className="inline-flex items-center gap-2 mt-8 px-7 py-4 bg-claret text-paper text-sm font-semibold tracking-wide hover:bg-claret-dark transition-colors">
              Explore places <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
